import * as API from "../../Utils/Services/api";
import { useEffect, useState, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { ethers, Contract, toBigInt, formatEther } from "ethers";
import { formatUnits, parseUnits } from "viem";
import translation from "../Translations/translation.json";
import { toast } from "react-toastify";
import { swapContract } from "../../Ethereum/Constant/addresses";
import { swapABI, poolABI, ERC20ABI } from "../../Ethereum/Constant/abis";
import { contractInstance, signer } from "../../Ethereum/Connect/config";
import { BrowserProvider } from "ethers";
import Loading from "../Loading/Loading";
import { useLanguage } from "../LanguageContext";
import getTokenBalance from "../../Utils/getTokenBalance";
import { safeParseUnits, isWethw } from "../../helpers/v3/unit";
import {
  getPoolStatus,
  getAllowance,
  quoteExactIn,
  approveMax,
  swapExactIn as doSwapExactIn,
  getPoolAddress,
} from "../../helpers/v3/v3";
import { ADDRS } from "../../Contracts/V3/addresses";
import { readBalance } from "../../helpers/readBalance";
import { publicClient } from "../../Contracts/V3/client";
import "./Banner.css";
import "../../App.css";
import "./V3Swap.css";
import { ABIS, ERC20 } from "../../Contracts/V3/abis";

const V3Swap = ({ handleVersionChange, selectedVersion }) => {
  const inReqId = useRef(0);
  const outReqId = useRef(0);
  const [value, setValue] = useState("");
  const containerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);
  const [estimateTokenValue, setEstimateTokenValue] = useState("");
  const [estimateETHWValue, setEstimateETHWValue] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [isSwapped, setIsSwapped] = useState(false);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const debounceTimeout = useRef(null);
  const [allTokensLoading, setAllTokensLoading] = useState(false);
  const [totalAllTokens, setTotalAllTokens] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const [ethwBalance, setEthwBalance] = useState(null);
  const [balance, setBalance] = useState("");
  const [error, setError] = useState("");
  const SLIPPAGE_OPTIONS = [
    { label: "0.5", value: 50 },
    { label: "1.00", value: 100 },
    { label: "2.00", value: 200 },
    { label: "5.00", value: 500 },
  ];
  const [slippage, setSlippage] = useState(100);
  const [ethwToTokenQuoteUI, setEthwToTokenQuoteUI] = useState("—");
  const [ethwToTokenQuoteBI, setEthwToTokenQuoteBI] = useState(0n);
  const [quoteOutUI, setQuoteOutUI] = useState("—");
  const [lastQuoteOut, setLastQuoteOut] = useState(0n);
  const [outQuoteBusy, setOutQuoteBusy] = useState(false);
  const [poolReady, setPoolReady] = useState(false);
  const [dec0, setDec0] = useState(18);
  const [dec1, setDec1] = useState(18);
  const [bal0, setBal0] = useState(0n);
  const [bal1, setBal1] = useState(0n);
  const [balNative, setBalNative] = useState(0n);
  const [payWithNative_IN, setPayWithNative_IN] = useState(false);
  const [receiveNative_IN, setReceiveNative_IN] = useState(false);
  const [IN_WETH, setIN_WETH] = useState(null);
  const [OUT_OTHER, setOUT_OTHER] = useState(null);
  const { toggleLanguage, language } = useLanguage();

  useEffect(() => {
    if (!selectedToken) return;
    const isWethwIn_IN = isWethw(selectedToken.address);
    const isWethwOut_IN = isWethw(ADDRS.WETHW);
    setPayWithNative_IN(isWethwIn_IN);
    setReceiveNative_IN(isWethwOut_IN);
    const in_weth = isWethw(selectedToken.address)
      ? selectedToken.address
      : isWethw(ADDRS.WETHW)
      ? ADDRS.WETHW
      : null;
    setIN_WETH(in_weth);
    const out_Other = isWethw(selectedToken.address)
      ? ADDRS.WETHW
      : selectedToken.address;
    setOUT_OTHER(out_Other);
  }, [selectedToken]);
  // Uniswap V3-style fee tiers
  const feeOptions = [
    // { bps: 100, pct: 0.01, label: "Best for very stable pairs" },
    { bps: 500, pct: 0.05, label: "Best for stable pairs" },
    { bps: 3000, pct: 0.3, label: "Best for most pairs" },
    { bps: 10000, pct: 1.0, label: "Best for exotic pairs" },
  ];

  const [feeTierBps, setFeeTierBps] = useState(parseInt(3000));

  useEffect(() => {
    if (!selectedToken) return;
    let mounted = true;
    (async () => {
      try {
        const st = await getPoolStatus(
          selectedToken.address,
          ADDRS.WETHW,
          feeTierBps
        );
        if (!mounted) return;
        if (!st.exists) {
          setPoolReady(false);
          toast(
            `${translate("swap.nopoolPrefix")}${(feeTierBps / 10000).toFixed(
              2
            )}%. ${translate("swap.nopoolSuffix")}`
          );
          // toast.info(
          //   `No pool at ${(feeTierBps / 10000).toFixed(
          //     2
          //   )}%. Create & initialize this fee tier first.`
          // );
        } else if (!st.initialized) {
          setPoolReady(false);
          toast(
            `${translate("swap.poolExistPre")}${(feeTierBps / 10000).toFixed(
              2
            )}%. ${translate("swap.poolExistSuf")}`
          );
          // toast.info(
          //   `Pool at ${(feeTierBps / 10000).toFixed(
          //     2
          //   )}% exists but is not initialized.`
          // );
        } else {
          setPoolReady(true);
        }
      } catch (e) {
        if (!mounted) return;
        setPoolReady(false);
        toast.error(
          e?.shortMessage || e?.message || translate("swap.poolCheckFailed")
        );
      }
    })();
    return () => {
      mounted = false;
    };
  }, [feeTierBps, selectedToken]);

  const fetchETHWBalance = async () => {
    try {
      if (!window.ethereum) {
        // setError("MetaMask is not installed!");
        setEthwBalance(null);
        return;
      }

      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (!accounts.length) {
        setEthwBalance(null);
        return;
      }

      const provider = new BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();

      const balance = await provider.getBalance(signer.address);
      const formattedBalance = parseFloat(ethers.formatEther(balance)).toFixed(
        6
      );
      setEthwBalance(formattedBalance);
      setError("");
    } catch (err) {
      console.error("Error fetching ETHW balance:", err.message);
      // setError("Failed to fetch balance. Please try again.");
      setError(translate("fetchBalanceFailed"));
      setEthwBalance(null);
    }
  };

  const fetchTokenBalance = async () => {
    if (!window.ethereum || !selectedToken?.address) {
      setBalance("");
      return;
    }

    try {
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (!accounts.length) {
        setBalance("");
        return;
      }

      const provider = new BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();

      // Create token contract instance
      const tokenContract = new ethers.Contract(
        selectedToken.address,
        [
          "function balanceOf(address account) view returns (uint256)",
          "function decimals() view returns (uint8)",
        ],
        provider
      );

      const rawBalance = await tokenContract.balanceOf(signer.address);
      const decimals = await tokenContract.decimals();
      setBalance(
        parseFloat(ethers.formatUnits(rawBalance, decimals)).toFixed(6)
      );
    } catch (err) {
      console.error(err);
      // setBalance("Error fetching balance");
      setBalance(translate("errorFetchingBalance"));
    }
  };
  useEffect(() => {
    const connectedWallet = sessionStorage.getItem("account");
    if (!connectedWallet) {
      setEthwBalance(null);
      setBalance("");
    } else {
      fetchETHWBalance();
      fetchTokenBalance();
    }
  }, [selectedToken]);
  // new close
  // Refresh balances
  const refresh = useCallback(async () => {
    const connectedWallet = sessionStorage.getItem("account");
    if (!connectedWallet || !selectedToken) return;
    const provider = new BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();

    // const balance = await provider.getBalance(signer.address);
    const [b0, b1, a0, bn] = await Promise.all([
      readBalance(selectedToken.address, connectedWallet).catch(() => 0n),
      readBalance(ADDRS.WETHW, connectedWallet).catch(() => 0n),
      getAllowance(connectedWallet, selectedToken.address).catch(() => 0n),
      provider.getBalance(signer.address).catch(() => 0n),
      // publicClient.getBalance({ connectedWallet }).catch(() => 0n),
    ]);
    setBalNative(bn);
  }, [selectedToken]);
  useEffect(() => {
    refresh();
  }, [refresh]);

  /// ETHW input in as sell and out amount of token user will get
  useEffect(() => {
    if (isSwapped) return;
    let mounted = true;
    const myId = ++outReqId.current;
    setOutQuoteBusy(true);
    setEthwToTokenQuoteUI("—");
    setEthwToTokenQuoteBI(0n);
    const t = setTimeout(async () => {
      try {
        if (!poolReady || !IN_WETH) return;
        const ethwIn = safeParseUnits(estimateETHWValue, 18n);
        if (ethwIn === null || ethwIn <= 0n) return;
        const out = await quoteExactIn({
          tokenIn: IN_WETH,
          tokenOut: OUT_OTHER,
          feeTierBps,
          amountIn: ethwIn,
        });
        if (!mounted || myId !== outReqId.current) return;
        // OUT_OTHER decimals:
        const outDec =
          OUT_OTHER.toLowerCase() === selectedToken.address.toLowerCase()
            ? dec0
            : dec1;
        setEthwToTokenQuoteUI(formatUnits(out, outDec));
        setEstimateTokenValue(formatUnits(out, outDec));
        setEthwToTokenQuoteBI(out);
      } catch (err) {
        console.log("ERROR::", err);
        // ignore quote errors
      } finally {
        if (mounted && myId === outReqId.current) setOutQuoteBusy(false);
      }
    }, 250);
    return () => {
      mounted = false;
      clearTimeout(t);
    };
  }, [
    isSwapped,
    estimateETHWValue,
    feeTierBps,
    poolReady,
    IN_WETH,
    OUT_OTHER,
    selectedToken,
    dec0,
    dec1,
  ]);

  /// Token input in as sell and out amount of ETHW user will get
  useEffect(() => {
    if (!isSwapped) return;
    let mounted = true;
    setError("");
    const myId = ++inReqId.current;
    const t = setTimeout(async () => {
      try {
        if (!poolReady) {
          if (mounted) {
            setQuoteOutUI("—");
            setLastQuoteOut(0n);
          }
          return;
        }
        const ain = safeParseUnits(estimateTokenValue, toBigInt(dec0));
        if (ain === null || ain <= 0n) {
          if (mounted) {
            setQuoteOutUI("—");
            setLastQuoteOut(0n);
          }
          return;
        }
        const out = await quoteExactIn({
          tokenIn: selectedToken.address,
          tokenOut: ADDRS.WETHW,
          feeTierBps,
          amountIn: ain,
        });
        if (!mounted || myId !== inReqId.current) return;
        setQuoteOutUI(formatUnits(out, dec1));
        setEstimateETHWValue(formatUnits(out, dec1));
        setLastQuoteOut(out);
      } catch (err) {
        console.log("ERROR:::", err);
        if (mounted && myId === inReqId.current) {
          setQuoteOutUI("—");
          setLastQuoteOut(0n);
        }
      }
    }, 250);
    return () => {
      mounted = false;
      clearTimeout(t);
    };
  }, [
    isSwapped,
    estimateTokenValue,
    feeTierBps,
    poolReady,
    selectedToken,
    dec1,
  ]);

  const swapDivs = () => {
    setIsSwapped(!isSwapped);
  };

  const getAllTokenDetail = async (
    page = 1,
    size = rowsPerPage,
    filter = ""
  ) => {
    try {
      setAllTokensLoading(true);
      const data = {
        page,
        size,
        filter,
      };
      const resp = await API.GetAllTokenV3(data);
      // setTokenData(resp.data.tokens);
      const tokens = resp.data.tokens || [];
      setTokenData((prev) => (page === 1 ? tokens : [...prev, ...tokens]));
      setTotalAllTokens(resp.data.total);
      setTotalPages(Math.ceil(resp.data.total / size));
      setAllTokensLoading(false);
    } catch (err) {
      // toast.error(err.response.data.message);
      toast.info(translate("swap.noTokenFound"));
      setTokenData([]);
      setAllTokensLoading(false);
      setTotalAllTokens(0);
      setTotalPages(1);
    }
  };
  useEffect(() => {
    getAllTokenDetail();
  }, []);

  const selectHandler = (e) => {
    const filter = e.target.value;
    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setCurrentPage(1);
      setTokenData([]);
      getAllTokenDetail(1, rowsPerPage, filter);
    }, 500);
  };

  const selectTokenHandler = (data) => {
    setSelectedToken(data);
  };
  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || allTokensLoading) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 50
    ) {
      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        getAllTokenDetail(nextPage, rowsPerPage, selectedToken || "");
      }
    }
  };

  const swapHandler = async () => {
    const connectedWallet = sessionStorage.getItem("account");
    if (!connectedWallet) return;
    const pool = await getPoolAddress(
      ADDRS.WETHW,
      selectedToken.address,
      feeTierBps
    );
    const tokenReserve = await publicClient.readContract({
      address: selectedToken.address,
      abi: ERC20,
      functionName: "balanceOf",
      args: [pool],
    });

    const ethwReserve = await publicClient.readContract({
      address: ADDRS.WETHW,
      abi: ERC20,
      functionName: "balanceOf",
      args: [pool],
    });
    const slot0 = await publicClient.readContract({
      address: pool,
      abi: ABIS.pool,
      functionName: "slot0",
    });
    const tokenBalance = await publicClient.readContract({
      address: selectedToken.address,
      abi: ERC20,
      functionName: "balanceOf",
      args: [connectedWallet],
    });

    if (isSwapped) {
      setBusy(true);
      setError("");
      toast.info(translate("swap.approvingRouter"));
      try {
        // Approving
        const ain = safeParseUnits(estimateTokenValue, toBigInt(dec0));
        const amountToApprove = ain !== null && ain > 0n ? ain : bal0;
        await approveMax(selectedToken.address, amountToApprove);
        await refresh();
        toast.info(translate("swap.approved"));

        // Swapping transaction
        if (!poolReady) throw new Error(translate("swap.poolNotReady"));
        if (ain === null || ain <= 0n)
          throw new Error(translate("swap.validAmount"));

        // balance checks for input (User's token)
        // if (payWithNative_IN && isWethw(selectedToken.address)) {
        //   if (ain > balNative)
        //     throw new Error("Insufficient native ETHW balance");
        // } else {
        //   if (ain > bal0) throw new Error("Insufficient input balance");
        // }

        const quotedOut =
          lastQuoteOut && lastQuoteOut > 0n
            ? lastQuoteOut
            : await quoteExactIn({
                tokenIn: selectedToken.address,
                tokenOut: ADDRS.WETHW,
                feeTierBps,
                amountIn: ain,
              });

        const minOut = (quotedOut * toBigInt(10000 - slippage)) / 10000n;

        // allowance if ERC-20 path (not needed if paying native & input is WETHW)
        const currentAllow = await getAllowance(
          connectedWallet,
          selectedToken.address
        ).catch(() => 0n);
        if (
          !(payWithNative_IN && isWethw(selectedToken.address)) &&
          currentAllow < ain
        ) {
          toast.info(translate("swap.approvingRouter"));
          await approveMax(selectedToken.address, ain);
        }

        toast.info(
          isWethw(ADDRS.WETHW) && receiveNative_IN
            ? translate("swap.swappingNative")
            : translate("swap.swapping")
        );

        const resp = await doSwapExactIn({
          tokenIn: selectedToken.address,
          tokenOut: ADDRS.WETHW,
          fee: feeTierBps,
          amountIn: ain,
          minOut,
          recipient: connectedWallet,
          payWithNative: isWethw(selectedToken.address) && payWithNative_IN,
          unwrapToNative: isWethw(ADDRS.WETHW) && receiveNative_IN,
        });

        await API.TokenSwapV3({
          maker: connectedWallet,
          ethwOut: parseFloat(formatEther(minOut)),
          tokenIn: parseFloat(formatEther(ain)),
          txHash: resp.transactionHash,
          poolAddress: pool,
          isBuyEthw: true,
          tokenAddress: selectedToken.address,
          blockNumber: Number(resp.blockNumber),
          ethwReserve: parseFloat(formatEther(ethwReserve)),
          tokenReserve: parseFloat(formatEther(tokenReserve)),
          sqrtPriceX96: parseFloat(formatEther(slot0[0])),
          tokenBalance: parseFloat(formatEther(tokenBalance)),
        });

        toast.success(translate("swap.swapDone"));
        await refresh();
        setBusy(false);
      } catch (err) {
        setBusy(false);
        toast.error(err?.message);
        console.log("ERROR:::", err, "tx", err.message);
      }
    } else {
      if (!connectedWallet) return;
      setBusy(true);
      setError("");
      toast.info(translate("swap.swappingSpend"));
      try {
        if (!poolReady) throw new Error(translate("swap.poolNotReady"));
        if (!IN_WETH) throw new Error("WETHW address not set in ADDRS");

        const ethwIn = safeParseUnits(estimateETHWValue, 18n);
        if (ethwIn === null || ethwIn <= 0n)
          throw new Error(translate("swap.validAmount"));
        if (ethwIn > balNative)
          throw new Error(translate("swap.insufficientETHW"));

        // get or reuse quote -> compute minOut with slippage
        const quotedOut =
          ethwToTokenQuoteBI > 0n
            ? ethwToTokenQuoteBI
            : await quoteExactIn({
                tokenIn: IN_WETH,
                tokenOut: OUT_OTHER,
                feeTierBps,
                amountIn: ethwIn,
              });

        const minOut = (quotedOut * toBigInt(10000 - slippage)) / 10000n;

        const resp = await doSwapExactIn({
          tokenIn: IN_WETH,
          tokenOut: OUT_OTHER,
          fee: feeTierBps,
          amountIn: ethwIn,
          minOut,
          recipient: connectedWallet,
          payWithNative: true,
          unwrapToNative: false,
        });

        const pool = await getPoolAddress(IN_WETH, OUT_OTHER, feeTierBps);

        const response = await API.TokenSwapV3({
          maker: connectedWallet,
          ethwIn: parseFloat(formatEther(ethwIn)),
          tokenOut: parseFloat(formatEther(minOut)),
          txHash: resp.transactionHash,
          poolAddress: pool,
          isBuyEthw: false,
          tokenAddress: selectedToken.address,
          blockNumber: Number(resp.blockNumber),
          ethwReserve: parseFloat(formatEther(ethwReserve)),
          tokenReserve: parseFloat(formatEther(tokenReserve)),
          sqrtPriceX96: parseFloat(formatEther(slot0[0])),
          tokenBalance: parseFloat(formatEther(tokenBalance)),
        });

        toast.success(translate("swap.swapDone"));
        await refresh();
      } catch (e) {
        setError(e?.shortMessage || e?.message || String(e));
      } finally {
        setBusy(false);
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="swapping-versions">
        <div className="dropdown">
          <button
            className="btn dropdown-btn-pool select-ver-dropdown-swap"
            type="button"
            onClick={() => setIsDropdownOpen((prev) => !prev)}
          >
            {selectedVersion}
            <i className="fa fa-angle-down ms-1"></i>
          </button>
          {isDropdownOpen && (
            <ul
              className="dropdown-menu show select-ver-dropdown"
              style={{ display: "block", position: "absolute" }}
            >
              <li>
                <button
                  className="dropdown-item text-light"
                  onClick={() => {
                    handleVersionChange("v2");
                    setIsDropdownOpen(false);
                  }}
                >
                  v2
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item text-light"
                  onClick={() => {
                    handleVersionChange("v3");
                    setIsDropdownOpen(false);
                  }}
                >
                  v3
                </button>
              </li>
            </ul>
          )}
        </div>{" "}
        <div className="settings-v3-swap">
          <button
            className="btn dropdown-btn-pool select-ver-dropdown-swap drop-btn--gear"
            type="button"
            aria-haspopup="menu"
            aria-expanded={settingsOpen}
            aria-controls="v3-settings-menu"
            onClick={() => {
              setIsDropdownOpen(false);
              setSettingsOpen((o) => !o);
            }}
          >
            <i className="fa fa-gear"></i>
          </button>

          {settingsOpen && (
            <div
              className="settings-overlay"
              onClick={() => {
                setIsDropdownOpen(false);
                setSettingsOpen(false);
              }}
            />
          )}

          {settingsOpen && (
            <div
              id="v3-settings-menu"
              className="v3-dropdown"
              role="menu"
              tabIndex={-1}
              autoFocus
              onKeyDown={(e) => e.key === "Escape" && setSettingsOpen(false)}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="v3-dropdown-header">
                <h6>{translate("swap.transactionSettings")}</h6>
                <button
                  className="icon-btn"
                  aria-label="Close"
                  onClick={() => setSettingsOpen(false)}
                >
                  ✕
                </button>
              </div>
              <div className="v3-dropdown-section">
                <label className="v3-label">
                  {translate("swap.slippageTolerance")}
                </label>
                <div className="v3-row">
                  <select
                    className="v3-select"
                    value={slippage}
                    onChange={(e) => setSlippage(Number(e.target.value))}
                    aria-label="Slippage tolerance"
                  >
                    {SLIPPAGE_OPTIONS.map((opt) => (
                      <option key={opt.label} value={opt.value}>
                        {opt.label}%
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="v3-dropdown-section">
                <label className="v3-label">{translate("swap.fees")}</label>

                <div
                  className="v3-fee-grid"
                  role="radiogroup"
                  aria-label="Select fee tier"
                >
                  {feeOptions?.map((opt) => {
                    const id = `fee-${opt.bps}`;
                    const checked = feeTierBps === opt.bps;
                    return (
                      <label
                        key={opt.bps}
                        className={`v3-fee-card ${
                          checked ? "is-selected" : ""
                        }`}
                        htmlFor={id}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setFeeTierBps(opt.bps);
                          }
                        }}
                      >
                        <input
                          id={id}
                          type="radio"
                          name="fee-tier"
                          value={opt.bps}
                          checked={checked}
                          onChange={() => setFeeTierBps(opt.bps)}
                        />
                        <div className="v3-fee-top">
                          <span className="v3-fee-pct">{opt.pct}%</span>
                        </div>
                        {/* <div className="v3-fee-desc">{opt.label}</div> */}
                      </label>
                    );
                  })}
                </div>
              </div>{" "}
              <div className="v3-dropdown-section">
                <label className="v3-label">
                  {" "}
                  {translate("swap.deadline")}
                </label>
                <div className="v3-row">
                  <input
                    type="number"
                    min="1"
                    step="1"
                    placeholder="10 min"
                    disabled
                    className="v3-input"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {!isSwapped ? (
        <>
          <div className="swap-value mb-1">
            <div className="grey-color">{translate("banner.actions.sell")}</div>
            <div className="enter-val grey-color">
              <div className="grey-color">
                <input
                  type="text"
                  value={estimateETHWValue}
                  onChange={(e) => setEstimateETHWValue(e.target.value)}
                  placeholder="0"
                  id="number-input"
                  className="text-white "
                  autoComplete="off"
                  // onKeyDown={(e) => {
                  //   if (
                  //     !/[0-9.]/.test(e.key) &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "Delete" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  // disabled
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  flexDirection: "column",
                }}
              >
                <button type="button" className="btn backdrop-btn-css">
                  <div className="flex-class text-white ">
                    <img
                      src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                      alt=""
                      className="modal-img-btn"
                    />
                    ETHW
                  </div>
                </button>
                <div style={{ fontSize: "small", width: "7rem" }}>
                  {ethwBalance !== null ? <>{ethwBalance} ETHW </> : <></>}

                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              </div>
            </div>
            <div className="loading-div"></div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={swapDivs}
          >
            <i
              className="fa fa-arrow-down "
              style={{
                color: "#fff",
                cursor: "pointer",
                backgroundColor: " rgb(32, 32, 32)",
                padding: "10px",
                position: "absolute",
                borderRadius: "10px",
              }}
            ></i>
          </div>
          <div className="swap-value mt-1">
            <div className="grey-color">{translate("banner.actions.buy")}</div>
            <div className="enter-val grey-color">
              <div className="grey-color">
                {outQuoteBusy ? (
                  <Loading />
                ) : (
                  <input
                    type="text"
                    placeholder="0"
                    id="number-input"
                    value={estimateTokenValue}
                    className="text-white "
                    // onChange={handleTokenInput}
                    autoComplete="off"
                  />
                )}
              </div>
              <div className="select-token-btn">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-modal-backdrop"
                    data-bs-toggle="modal"
                    data-bs-target="#selecttoken2"
                  >
                    <div
                      className="flex-class text-white "
                      style={{ textWrap: "nowrap" }}
                    >
                      {selectedToken ? (
                        <>
                          <img
                            src={selectedToken?.image}
                            alt=""
                            className="modal-img-btn"
                          />
                          {selectedToken.symbol?.toUpperCase()}
                        </>
                      ) : (
                        translate("banner.actions.selectToken")
                      )}
                      <i className="fa fa-angle-down"></i>
                    </div>
                  </button>{" "}
                  <div
                    style={{
                      fontSize: "small",
                      // width: "6rem",
                      whiteSpace: "nowrap",
                      // overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {selectedToken
                      ? `${
                          balance !== null
                            ? `${balance} ${selectedToken.symbol?.toUpperCase()}`
                            : ""
                        }`
                      : ""}
                  </div>
                </div>
                <div
                  className="modal "
                  id="selecttoken2"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          {translate("banner.actions.selectToken")}
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div
                        className="modal-body"
                        ref={containerRef}
                        onScroll={handleScroll}
                        style={{
                          maxHeight: "80vh",
                          overflowY: "auto",
                        }}
                      >
                        <input
                          type="text"
                          name="userToken"
                          placeholder={translate("enterContractAddress")}
                          className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                          // value={selectToken}
                          onChange={selectHandler}
                          autoComplete="off"
                        />{" "}
                        {tokenData?.length === 0 && allTokensLoading && (
                          <Loading />
                        )}
                        {tokenData?.length === 0 && !allTokensLoading && (
                          <div className="suggestion-item">
                            {translate("noResultFound")}
                          </div>
                        )}
                        {tokenData && tokenData.length > 0 && (
                          <>
                            {tokenData.map((suggestion, index) => (
                              <div
                                key={index}
                                className="suggestion-item token-suggestions-data"
                                data-bs-dismiss="modal"
                                onClick={() => selectTokenHandler(suggestion)}
                              >
                                <div className="suggestion-img">
                                  <img src={suggestion?.image} alt="" />
                                </div>
                                <div className="model-data-flex">
                                  <div className="suggestion-name">
                                    {suggestion?.name} (
                                    <strong>
                                      {suggestion?.symbol.toUpperCase()}
                                    </strong>
                                    )
                                  </div>
                                  <div className="suggestion-sym contract-add-model">
                                    {suggestion?.address}
                                  </div>
                                </div>
                              </div>
                            ))}
                            {allTokensLoading && <Loading />}{" "}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        <>
          {" "}
          <div className="swap-value mb-1">
            <div className="grey-color">{translate("banner.actions.sell")}</div>
            <div className="enter-val grey-color">
              <div className="grey-color">
                <input
                  type="text"
                  placeholder="0"
                  id="number-input"
                  value={estimateTokenValue}
                  className="text-white "
                  onChange={(e) => setEstimateTokenValue(e.target.value)}
                  autoComplete="off"
                />
              </div>
              <div className="select-token-btn">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-modal-backdrop"
                    data-bs-toggle="modal"
                    data-bs-target="#selecttoken3"
                  >
                    <div
                      className="flex-class text-white "
                      style={{ textWrap: "nowrap" }}
                    >
                      {selectedToken ? (
                        <>
                          <img
                            src={selectedToken?.image}
                            alt=""
                            className="modal-img-btn"
                          />
                          {selectedToken?.symbol.toUpperCase()}
                        </>
                      ) : (
                        translate("banner.actions.selectToken")
                      )}
                      <i className="fa fa-angle-down "></i>
                    </div>
                  </button>
                  <div
                    style={{
                      fontSize: "small",
                      // width: "6rem",
                      whiteSpace: "nowrap",
                      // overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {" "}
                    {/* {ethwBalance !== null ? (
                            <>{ethwBalance} ETHW </>
                          ) : (
                            <></>
                          )} */}
                    {selectedToken
                      ? `${
                          balance !== null
                            ? `${balance} ${selectedToken?.symbol?.toUpperCase()}`
                            : ""
                        }`
                      : ""}
                  </div>
                </div>
                <div
                  className="modal "
                  id="selecttoken3"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          {translate("banner.actions.selectToken")}
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <input
                          type="text"
                          name="userToken"
                          placeholder={translate("enterContractAddress")}
                          className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                          // value={selectToken}
                          onChange={selectHandler}
                          autoComplete="off"
                        />
                        {tokenData ? (
                          tokenData.map((suggestion, index) => (
                            <div
                              key={index}
                              className="suggestion-item token-suggestions-data"
                              onClick={() => selectTokenHandler(suggestion)}
                              data-bs-dismiss="modal"
                            >
                              <div className="suggestion-img">
                                <img src={suggestion?.image} alt="" />
                              </div>
                              <div className="model-data-flex">
                                <div className="suggestion-name">
                                  {suggestion?.name} (
                                  <strong>
                                    {suggestion?.symbol.toUpperCase()}
                                  </strong>
                                  )
                                </div>
                                <div className="suggestion-sym contract-add-model">
                                  {suggestion?.address}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="suggestion-item">
                            {translate("noResultFound")}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={swapDivs}
          >
            <i
              className="fa fa-arrow-down "
              style={{
                cursor: "pointer",
                color: "#fff",
                backgroundColor: " rgb(32, 32, 32)",
                padding: "10px",
                position: "absolute",
                borderRadius: "10px",
              }}
            ></i>
          </div>{" "}
          <div className="swap-value mt-1">
            <div className="grey-color">{translate("banner.actions.buy")}</div>
            <div className="enter-val grey-color">
              <div className="grey-color">
                <input
                  type="text"
                  value={estimateETHWValue}
                  // onChange={handleETHWSwapInput}
                  placeholder="0"
                  id="number-input"
                  className="text-white "
                  autoComplete="off"
                  // onKeyDown={(e) => {
                  //   if (
                  //     !/[0-9.]/.test(e.key) &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "Delete" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  flexDirection: "column",
                }}
              >
                <button
                  type="button"
                  className="btn btn-modal-backdrop"
                  // data-bs-toggle="modal"
                  // data-bs-target="#selecttoken4"
                >
                  <div className="flex-class text-white ">
                    <img
                      src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                      alt=""
                      className="modal-img-btn"
                    />
                    ETHW
                    {/* <i className="fa fa-angle-down grey-clr"></i> */}
                  </div>
                </button>
                <div style={{ fontSize: "small", width: "7rem" }}>
                  {ethwBalance !== null ? <>{ethwBalance} ETHW </> : <></>}

                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showModal && (
        <div
          className="modal modal-backcss show d-block"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog   modal-dialog-centered" role="document">
            <div className="modal-content text-center">
              <div className="modal-header">
                <h5 className="modal-title">
                  {/* Swap Successful */}
                  {translate("swapSuccessful")}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <p style={{ marginBottom: "0" }}>
                  {/* Tokens swapped successfully! */}
                  {translate("tokensSwappedSuccess")}{" "}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  style={{
                    backgroundColor: "#00a8e8",
                    color: "#fff",
                    fontWeight: "500",
                  }}
                  type="button"
                  className="btn"
                  onClick={closeModal}
                >
                  {/* Close */} {translate("close")}{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`get-started-btn ${!selectedToken ? "disabled" : ""}`}
        onClick={swapHandler}
        // disabled={!selectedToken || loading}
      >
        <button
          className="text-white "
          disabled={!selectedToken || loading}
          style={{
            cursor: selectedToken ? "pointer" : "no-drop",
            backgroundColor: !selectedToken ? "grey" : "",
          }}
        >
          {busy ? <Loading /> : translate("banner.actions.getStarted")}
        </button>{" "}
      </div>
      {!selectedToken && (
        <p style={{ textAlign: "center" }}>
          {translate("banner.selectTokenWarning")}
          {/* Please select a token to get started */}
        </p>
      )}
    </>
  );
};

export default V3Swap;
